import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
const state = {



};

const getters = {



};

const actions = {


    fetchLists : async (context,settings) => {


        let url = "statusorders";

        //console.log(context.rootGetters['profile/getToken'])
        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);

                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },




};

const mutations = {




};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
